
import React, { useEffect } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { useTranslation } from 'react-i18next'

import StreamCard from '../StreamCard'
import defaultImage from '../../../assets/images/TestBanner.png'

const styles = theme => ({
  cardsContainer: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap'
  }
})

const MyEvents = ({ classes, streams, fetchInterestingEventsSterams, removeInterestingEvent }) => {
  const { t } = useTranslation()

  useEffect(() => {
    if (streams === undefined) {
      fetchInterestingEventsSterams()
    }
  })
  if (!streams) return null

  return (
    <div className={classes.cardsContainer}>
      {
        streams && streams.map(stream => (
          <StreamCard
            key={stream.id}
            image={defaultImage}
            title={stream.title}
            descr={stream.description}
            price={'$100 USD'}
            startDate={stream.startDate}
            actionLabel={t('Cabinet:watch stream')}
            removeStream={() => (removeInterestingEvent(stream.id))}
            removeConfirmText={t('Cabinet:remove interesting stream confirm')}
          />
        ))
      }
    </div>
  )
}

export default withStyles(styles)(MyEvents)
